<div>
	<div class="compliance-container">
		<div class="compliance-container-inner">
			<img
				class="d-none d-md-block orange-pattern-overlay"
				src="../../assets/img/orange-pattern.png"
				alt=""
			/>
			<img
				class="d-md-none orange-pattern-overlay"
				src="../../assets/img/orange-pattern-mobile.png"
				alt=""
			/>
			<div class="grid-wrapper text-center">
				<h2
					class="d-none d-md-block compliance-header text-center mb-5"
				>
					Featured Integrations
				</h2>
				<div class="row">
					<div class="col-md-4 mb-5 mb-lg-0">
						<img
							class="challenges-list-img"
							src="../../assets/img/nist.svg"
							alt=""
						/>
						<div class="challenges-list-head">NIST OSCAL</div>
						<div class="challenges-list-content">
							Integrated with the NIST OSCAL
							<br class="d-none d-xl-block" />
							standard to import and load catalogues
							<br class="d-none d-xl-block" />
							(i.e. NIST 800-53) automatically along
							<br class="d-none d-xl-block" />
							with industry first support for free tools
							<br class="d-none d-xl-block" />
							that export OSCAL content against
							<br class="d-none d-xl-block" />
							Version 1.0 of the standard.
						</div>
					</div>
					<div class="col-md-4 mb-5 mb-lg-0">
						<img
							class="challenges-list-img"
							src="../../assets/img/mitre.svg"
							alt=""
						/>
						<div class="challenges-list-head">MITRE SAF</div>
						<div class="challenges-list-content">
							Integrated with the MITRE Security
							<br class="d-none d-xl-block" />
							Automation Framework (SAF) to perform
							<br class="d-none d-xl-block" />
							automated assessments against the DISA
							<br class="d-none d-xl-block" />
							STIGS which are then mapped to NIST<br
								class="d-none d-md-block"
							/>
							800-53 security controls.
						</div>
					</div>
					<div class="col-md-4 mb-5 mb-lg-0">
						<img
							class="challenges-list-img"
							src="../../assets/img/csa.svg"
							alt=""
						/>
						<div class="challenges-list-head">
							Cloud Security Alliance (CSA)
						</div>
						<div class="challenges-list-content">
							Integrated the CSA Cloud Controls Matrix
							<br class="d-none d-xl-block" />
							(CCM) and Consensus Assessment Initiative
							<br class="d-none d-xl-block" />
							Questionnaire (CAIQ) to create security plans
							<br class="d-none d-xl-block" />
							that are mapped to over 40 cyber security
							<br class="d-none d-xl-block" />
							compliance standards around the world.
						</div>
					</div>
				</div>
				<a class="d-lg-none" href="https://go.regscale.com/RegScale-Create-Account">
					<button class="complaince-button py-2 px-5 mt-2 mt-lg-5">
						See For Yourself
					</button></a
				>
			</div>
		</div>
	</div>
</div>
